import { render } from "./ProjectSpecsCard.vue?vue&type=template&id=42ea8b40&scoped=true"
import script from "./ProjectSpecsCard.vue?vue&type=script&lang=js"
export * from "./ProjectSpecsCard.vue?vue&type=script&lang=js"

import "./ProjectSpecsCard.vue?vue&type=style&index=0&id=42ea8b40&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42ea8b40"]])

export default __exports__